import { ArrowRightIcon } from '@phosphor-icons/react';

import { Button } from 'components/button/Button';
import { Input } from 'components/input/Input';
import { Pill } from 'components/pill/Pill';

import { useAIDraftCtx } from './context';

export const NameStep = () => {
  const { state, dispatch } = useAIDraftCtx();

  return (
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-8">
        <div className="mb-4">
          <Pill color="primary" size="md">
            Stap 1
          </Pill>
        </div>
        <h2 className="heading-one mb-2">Geef je draft een naam</h2>
        <p className="text-fg-secondary">Kies een herkenbare naam zodat je deze draft later makkelijk terugvindt.</p>
      </div>

      <div className="mb-6">
        <label className="label-text block mb-1.5">Naam</label>
        <Input
          type="text"
          value={state.draftName}
          onChange={(val) => dispatch({ type: 'SET_DRAFT_NAME', draftName: val })}
          placeholder="bv. Klant X - Q2 tarieven"
        />
      </div>

      <div className="flex justify-center">
        <Button
          color="primary"
          onTrigger={() => dispatch({ type: 'GO_FORWARD' })}
          isDisabled={!state.draftName.trim()}
          iconRight={<ArrowRightIcon className="button-icon" />}
        >
          Volgende
        </Button>
      </div>
    </div>
  );
};
